import type {
  InspectionTypeRequest,
  InspectionTypeResponse,
} from 'src/api/ProactApiClient';
import type {IFormFieldV2} from 'src/types/FormV2';

export const InspectionTypeDocumentTitle = 'Inspection Types';

export const InspectionTypeFormMeta: IFormFieldV2[] = [
  {
    name: 'name',
    label: 'Name',
    type: 'text',
    required: true,
    validation: {maxLength: 255},
    size: 'md',
  },
  {
    name: 'standards',
    label: 'Standards',
    type: 'text',
    required: false,
    description: 'Display only — e.g. NFPA 10/72',
    validation: {maxLength: 200},
    size: 'md',
  },
];

export const InspectionTypeViewGeneralMeta: IFormFieldV2[] =
  InspectionTypeFormMeta;

// The API sends explicit `null` where the generated TS types say `undefined`.
export const MapInspectionTypeResponseToInspectionTypeRequest = (
  data: InspectionTypeResponse
): InspectionTypeRequest => {
  return {
    id: data.id,
    name: data.name,
    standards: data.standards || undefined,
  };
};
